import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import * as hooks from '@owl-nest/hooks'

import { useProductListing } from '../hooks/useProductListing'

export function Total(): React.ReactElement {
  const { response } = useProductListing()

  const total = hooks.data(response)?.nbHits

  return <DesktopOnly as="div">{total?.toLocaleString() ?? <plume.Spinner small />} produits triés par</DesktopOnly>
}

const BaseTotal = styled(plume.styles.copy.M)`
  font-weight: bold;
  margin-right: 8px;

  ${plume.Spinner} {
    display: inline;
    margin-right: 2px;
  }
`

const DesktopOnly = styled(BaseTotal)`
  display: none;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    display: block;
  }
`
